module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "preserve-search": false,
      "placeholder": "Add Channel",
      "label": "name",
      "track-by": "name"
    },
    on: {
      "select": _vm.addEncodingChannel,
      "remove": _vm.removeEncodingChannel
    }
  }), _c('vega-lite', {
    attrs: {
      "data": _vm.data,
      "mark": _vm.mark,
      "encoding": _vm.encoding
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e39b0382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./_docs/partials/examples/UpdateEncodingExample.vue
// module id = 1648
// module chunks = 1